module.exports = __webpack_public_path__ + "img/glsy-top-bg3.b9b54d0e.png";